// Packages
import axios from 'axios'

import { message } from 'antd'


const returnWorkbook = ({ startDate, endDate }) => {
	const args = { startDate, endDate }

	return axios({
		method: 'post',
		url: process.env.REACT_APP_ROUTE_CREATE_E2I_KIOSK_SPREADSHEET as string + `?startDate=${startDate}&endDate=${endDate}`,
		data: args,
		responseType: 'blob',
	}).then(({ data }) => {
		if (
			data.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		) {
			return data
		} else {
			message.warning('Data not found, kindly select the correct range.')
			return null
		}
	}).catch(()=>{
		message.warning('Data not found, kindly select the correct range.')
		return null
	})
}


const returnKioskData =  ({startDate, endDate}) => {
	const args = { startDate, endDate }
	return axios({
		method: 'post',
		url: process.env.REACT_APP_ROUTE_CREATE_E2I_KIOSK_SPREADSHEET as string + `/summary?startDate=${startDate}&endDate=${endDate}`,
		data: args,
		responseType: 'blob',
	}).then(({ data }) => {
		if (
			data.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		) {
			return data
		} else {
			message.warning('Data not found, kindly select the correct range.')
			return null
		}
	}).catch(()=>{
		message.warning('Data not found, kindly select the correct range.')
		return null
	})
}
export default {
	returnWorkbook,
	returnKioskData
}